import { useState } from "react";
import NxtbnDrawer from "../../drawer";
import { InputField } from "../../common";
import useApi from "../../../api";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchShippingMethod } from "../../../redux/shippingMethodSlice";

interface Props {
    edit?: any;
    isOpen: boolean;
    onClose: ()=>void;
}

function ShippingMethodForm({edit, isOpen, onClose}: Props) {
  
  const api = useApi()
  const dispatch = useDispatch()
  const [formData, setFormData] = useState<any>(edit ? edit : {})
  const [errorData, setErrorData] = useState<any>({})

  const onChangeInput = (e:any) => {
    const { name, value } = e.target
    setFormData((prev:any)=>({...prev, [name]: value}))
  }

  const onSubmit = (e:any, id?:number) => {
      e.preventDefault()
      if (!edit) { 
        api.createShippingMethod(formData).then((response:any)=>{
          toast.success("Shipping Method created")
          dispatch(fetchShippingMethod() as any)
          setFormData({})
          onClose()
        }, (error:any)=>setErrorData(error.response.data))
      } else {
        api.updateShippingMethod(id, formData).then((response:any)=>{
          toast.success('Successfully updated Shipping Method.')
          dispatch(fetchShippingMethod() as any)
          setFormData({})
          onClose()
        }, (error:any)=>setErrorData(error.response.data))
      }
    }
  return (
    <NxtbnDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={edit ? 'Edit Shipping Method' : 'Add Shipping Method'}
    >
      <div className="p-4">
        
        <form className="h-full overflow-y-auto px-2 my-2">
          <div className="flex flex-col w-full">
            <label htmlFor="name" className="text-sm text-base-300">
              Name
            </label>
            <div>
              <InputField
                id="name"
                type="text"
                name="name"
                value={formData?.name || ""}
                onChange={onChangeInput}
                placeholder="Enter Shipping Method name"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
              />
            </div>
          </div>
          <div className="flex flex-col w-full pt-6">
            <label htmlFor="description" className="text-sm text-base-300">
              Description
            </label>
            <div>
              <InputField
                id="description"
                type="text"
                name="description"
                value={formData?.description || ""}
                onChange={onChangeInput}
                placeholder="Enter Description"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
              />
            </div>
          </div>
          <div className="flex flex-col w-full pt-6">
            <label htmlFor="carrier" className="text-sm text-base-300">
              Carrier
            </label>
            <div>
              <InputField
                id="carrier"
                type="text"
                name="carrier"
                value={formData?.carrier || ""}
                onChange={onChangeInput}
                placeholder="Enter Carrier"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
              />
            </div>
          </div>

          <div className="mt-6 mb-6 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={(e: any) =>
                edit ? onSubmit(e, formData.id) : onSubmit(e)
              }
            >
              {edit ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </NxtbnDrawer>
  );
}

export default ShippingMethodForm;
